import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import {FormattedMessage} from 'react-intl';

import SideMenu from '../sideMenu/SideMenu';
import ChannelLink from '../../containers/channelUtils/ChannelLink';

export default class CategoryMenuProfile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {isMenuOpen: false};
  }

  render() {
    const {isMenuOpen} = this.state;
    const {title} = this.props;

    return (
      <div className={cx(
        'category-menu',
        isMenuOpen && 'category-menu--open'
      )}>
        <a className="category-menu__title" href="#" onClick={evt => {
          evt.preventDefault();
          this.setState({isMenuOpen: true});
        }}>
          {title}
        </a>

        <SideMenu
          isOpen={isMenuOpen}
          onStateChange={isMenuOpen => this.setState({isMenuOpen})}
        >
          <div className="side-menu__wrap">
            <div className="side-menu__nav">
              <ChannelLink
                to="/profile"
                className="side-menu__link"
              >
                <FormattedMessage id="section.profile.title"/>
              </ChannelLink>

              <ChannelLink
                to="/profile/orders"
                className="side-menu__link"
              >
                <FormattedMessage id="section.profile.orders"/>
              </ChannelLink>
            </div>
          </div>
        </SideMenu>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/categoryMenu/CategoryMenuProfile.js